import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Heading,
  Icon,
  SimpleGrid,
  useColorModeValue,
  Text,
  Stack,
  Alert,
  AlertIcon,
  Menu,
  MenuButton,
  MenuList,
  Input,
  Center,
  Button,
  HStack,
} from "@chakra-ui/react";

import {
  MdBarChart,
  MdBlockFlipped,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
  MdSearch,
  MdWarning,
  MdHelp,
  MdStore,
  MdImage,
  MdEmail,
  MdAdd,
  MdInfo,
  MdCheckCircle,
  MdReport,
  MdCompare,
  MdListAlt,
  MdShoppingCart,
  MdVerifiedUser,
} from "react-icons/md";

import { SiGooglesheets } from "react-icons/si";
import { BsFileEarmarkBarGraphFill } from "react-icons/bs";
import { sheetDownload } from "components/sheetDownload";

// import Card from "../../../components/card/Card"

import PieCard from "views/admin/default/components/PieCard";
import TestPie from "views/admin/default/components/TestPie";

import SuspectedBrandsTable from "views/admin/default/components/SuspectedBrandsTable";
import SuspectedSellers from "views/admin/default/components/SuspectedSellers";
import TestPurchaseTable from "views/admin/default/components/TestPurchaseTable";
import InfringingPlatforms from "views/admin/default/components/InfringingPlatforms";
import BarChart from "views/admin/default/components/BarChart";
import BrandAnalysisTable from "views/admin/default/components/BrandAnalysisTable";
import PlatformAnalysisTable from "views/admin/default/components/PlatformAnalysisTable";
import LookalikeInfringementBar from "views/admin/default/components/LookalikeInfringementBar";
import LookalikeInfringementTable from "views/admin/default/components/LookalikeInfrigementTable";

// import RevenueSavedTable from "views/admin/default/components/RevenueSavedTable";
import { useListContext } from "../../../contexts/listContext";
import { useCounter } from '../../../hooks/useCounter';

import { MdFilterAlt, MdCalendarMonth } from "react-icons/md";
import { motion } from "framer-motion";
import { ChevronDownIcon } from "@chakra-ui/icons";

export default function UserReports() {
  // Chakra Color Mode
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const { list, checkedPlatforms, abuse_type, dateFilter, setDateFilter } =
    useListContext();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [showCharts, setShowCharts] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const [topSuspectedBrands, setTopSuspectedBrands] = useState([]);
  // const [revenueSaved, setRevenueSaved] = useState([]);
  const [topSuspectedSellers, setTopSuspectedSellers] = useState([]);
  const [topInfringingPlatforms, setTopInfringingPlatforms] = useState([]);
  const [brandWise, setBrandWise] = useState([]);
  const [brandStatsData, setBrandStatsData] = useState([]);
  const [platformStatsData, setPlatformStatsData] = useState([]);
  const [platformWise, setPlatformWise] = useState([]);
  const [test, setTest] = useState([]);
  const [lookalikeInfringement, setLookalikeInfringement] = useState([]);
  const [countData, setCountData] = useState("");

  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");

  const defaultDateFilter = {
    startDate: new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  };

  const handleSuccessAlert = async (alertMessage) => {
    setSuccesAlert(alertMessage);
    setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
  };
  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  // const fetchRevenueSaved = async () => {
  //   try {
  //     //console.log("param", userInfo?.message?.result.id);
  //     const response = await fetch(`${backendUrl}/api/revenue/`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         uid: userInfo?.message?.result.id,
  //         durationType: dateFilter,
  //       }),
  //     });
  //     const json = await response.json();
  //     if (response.ok) {
  //       if (json.success === false) {
  //         handleFailureAlert(json.message);
  //       }

  //       setRevenueSaved(json.message.filter((it) => it.revenue));
  //     } else if (response.status !== 400) {
  //       handleFailureAlert("Error fetching Data");
  //     }
  //   } catch (e) {
  //     //console.log("error in fetchProducts");
  //   }
  // };

  const fetchTopSuspectedBrand = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(
        `${backendUrl}/api/report/topSuspectedBrands`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            durationType: dateFilter,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('TopSuspectedBrands fetched')
        setTopSuspectedBrands(json.data);
        //console.log("topSuspectedBrands", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in fetchProducts");
    }
  };

  const fetchTopSuspectedSellers = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(
        `${backendUrl}/api/report/topSuspectedSellers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            durationType: dateFilter,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('TopSuspectedSellers fetched')
        setTopSuspectedSellers(json.data);
        //console.log("TopSuspectedSellers", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in setTopSuspectedSellers");
    }
  };

  const fetchTopInfringingPlatforms = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(
        `${backendUrl}/api/report/topInfringingPlatforms`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            durationType: dateFilter,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('TopInfringingPlatforms fetched')
        setTopInfringingPlatforms(json.data);
        //console.log("TopInfringingPlatforms", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in TopInfringingPlatforms");
    }
  };

  const fetchBrandWise = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/report/brandWise`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          durationType: dateFilter,
        }),
      });
      const json = await response.json();
      if (response.ok) {
        //console.log('setBrandWise fetched')
        setBrandWise(json.data);
        //console.log("setBrandWise", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in setBrandWise");
    }
  };

  const fetchPlatformWise = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/report/platformWise`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          durationType: dateFilter,
        }),
      });
      const json = await response.json();
      if (response.ok) {
        //console.log('PlatformWise fetched')
        setPlatformWise(json.data);
        //console.log("PlatformWise", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in PlatformWise");
    }
  };

  const fetchTest = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/report/testCount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          durationType: dateFilter,
        }),
      });
      const json = await response.json();
      if (response.ok) {
        //console.log('testCount fetched')
        setTest(json.data);
        //console.log("testCoutn", json.data);
      } else if (response.status !== 200) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in testCount", e);
    }
  };

  const fetchLookalikeInfringement = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/report/lookalike-infringement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('testCount fetched')

        setLookalikeInfringement(json.data);

        //console.log("testCoutn", json.data);
      } else if (response.status !== 200) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (err) {
      // console.log("Error in fetchLookalikeInfringement", err);
    }
  };

  const fetchCount = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/revenue/statistics`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
        }),
      });
      const data = await response.json();
      console.log("count data", data.message);
      setCountData(data.message);
    } catch (e) {
      console.log("error in count api", e);
    }
  };

  const fetchBrandStats = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/revenue/brandStats`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
        }),
      });
      const data = await response.json();
      console.log("count data", data.message);
      setBrandStatsData(data.message);
    } catch (e) {
      console.log("error in count api", e);
    }
  };

  const fetchPlatformStats = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/revenue/platformStats`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
        }),
      });
      const data = await response.json();
      console.log("count data", data.message);
      setPlatformStatsData(data.message);
    } catch (e) {
      console.log("error in count api", e);
    }
  };

  const handleGenerateReport = () => {
    setShowCharts(true);
    fetchTopSuspectedBrand();
    fetchTopSuspectedSellers();
    fetchTopInfringingPlatforms();
    fetchBrandWise();
    fetchPlatformWise();
    fetchTest();
    fetchLookalikeInfringement();
  };

  useEffect(() => {
    // handleGenerateReport();
    fetchCount();
    fetchBrandStats();
    fetchPlatformStats();
  }, [userInfo?.message?.result.id]);

  useEffect(() => {
    if (showCharts) {
      handleGenerateReport();
    }
  }, [dateFilter]); // This will trigger report refresh when dates change

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );

  return (
    <>
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }} position="relative">
        {/* All Time Data Section - Always Visible */}
        <Box backgroundColor="white" rounded={10} p={6} mb={8}>
          <Heading size="lg" mb={10} color="gray.400" fontWeight="medium">
            All Time Analytics
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap="20px" my="35px">
            <Box
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="gray.200"
            >
              <Box position="absolute" top={0} right={-8}>
                <Icon
                  as={MdSearch}
                  width="130px"
                  height="130px"
                  color="gray.200"
                />
              </Box>
              <Text color="gray.500" fontSize="md">
                Detected
              </Text>
              <Text fontSize="3xl" fontWeight="bold" mt={2}>
                {useCounter(countData?.detectedCount)}
              </Text>
            </Box>

            <Box
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="gray.200"
            >
              <Box position="absolute" top={1} right={-8}>
                <Icon
                  as={MdHelp}
                  width="120px"
                  height="120px"
                  color="gray.200"
                />
              </Box>
              <Text color="gray.500" fontSize="md">
                Suspicious
              </Text>
              <Text fontSize="3xl" fontWeight="bold" mt={2}>
                {useCounter(countData?.suspiciousCount)}
              </Text>
            </Box>

            <Box
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="gray.200"
            >
              <Box position="absolute" top={0} right={-8}>
                <Icon
                  as={MdReport}
                  width="130px"
                  height="130px"
                  color="gray.200"
                />
              </Box>
              <Text color="gray.500" fontSize="md">
                Reported
              </Text>
              <Text fontSize="3xl" fontWeight="bold" mt={2}>
                {useCounter(countData?.reportedCount)}
              </Text>
            </Box>

            <Box
              bg="white"
              p={4}
              borderRadius="lg"
              boxShadow="md"
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="gray.200"
            >
              <Box position="absolute" top={1} right={-8}>
                <Icon
                  as={MdBlockFlipped}
                  width="120px"
                  height="120px"
                  color="gray.200"
                />
              </Box>
              <Text color="gray.500" fontSize="md">
                Takedown
              </Text>
              <Text fontSize="3xl" fontWeight="bold" mt={2}>
                {useCounter(countData?.takenDownCount)}
              </Text>
            </Box>
          </SimpleGrid>

          <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px" mb="20px">
            <BrandAnalysisTable finalData={brandStatsData} />
            <PlatformAnalysisTable finalData={platformStatsData} />
          </SimpleGrid>
        </Box>

        {/* See More Button - Centered and Animated */}
        {!showCharts && (
          <Flex position="relative" justify="center" top={-100}>
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <Button
                rightIcon={<ChevronDownIcon />}
                colorScheme="blue"
                variant="ghost"
                size="lg"
                borderWidth="1px"
                borderColor="gray.200"
                onClick={() => {
                  setShowCharts(true);
                  setShowDateFilter(true);
                  handleGenerateReport();
                  setTimeout(() => {
                    const element = document.getElementById("generate-report");
                    if (element) {
                      const headerOffset = 90; // height of your fixed header/navbar
                      const elementPosition =
                        element.getBoundingClientRect().top + window.scrollY;
                      const offsetPosition = elementPosition - headerOffset;

                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                      });
                    }
                  }, 100);
                }}
              >
                See Detailed Report
              </Button>
            </motion.div>
          </Flex>
        )}

        {/* Date Filter and Generate Report Section */}
        {showDateFilter && (
          <Box bg="gray.50" p={4} rounded="md" mb={4} id="generate-report">
            <Flex
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              gap={4}
            >
              <Flex gap={20}>
                <Flex gap={4}>
                  <Flex align="center">
                    <Text mr={2}>From:</Text>
                    <Input
                      type="date"
                      size="md"
                      value={dateFilter.startDate}
                      onChange={(e) => {
                        const newDateFilter = {
                          ...dateFilter,
                          startDate: e.target.value,
                        };
                        setDateFilter(newDateFilter);
                        // Store in localStorage for persistence
                        localStorage.setItem(
                          "reportDateFilter",
                          JSON.stringify(newDateFilter)
                        );
                      }}
                    />
                  </Flex>

                  <Flex align="center">
                    <Text mr={2}>To:</Text>
                    <Input
                      type="date"
                      size="md"
                      value={dateFilter.endDate}
                      onChange={(e) => {
                        const newDateFilter = {
                          ...dateFilter,
                          endDate: e.target.value,
                        };
                        setDateFilter(newDateFilter);
                        // Store in localStorage for persistence
                        localStorage.setItem(
                          "reportDateFilter",
                          JSON.stringify(newDateFilter)
                        );
                      }}
                    />
                  </Flex>
                </Flex>

                <Box>
                  <Flex>
                    <Button
                      leftIcon={<SiGooglesheets />}
                      colorScheme="green"
                      variant="ghost"
                      size="md"
                      onClick={() => sheetDownload(dateFilter)}
                    >
                      Export Excel
                    </Button>

                    <Button
                      as="a"
                      leftIcon={<BsFileEarmarkBarGraphFill />}
                      colorScheme="blue"
                      variant="ghost"
                      size="md"
                      href={`/report?dateFilter=${JSON.stringify(
                        dateFilter
                      )}&brand=${userInfo?.message?.result.name}`}
                      target="_blank"
                    >
                      View Report
                    </Button>
                  </Flex>
                </Box>
              </Flex>
              <Button
                colorScheme="blue"
                variant="ghost"
                size="md"
                borderWidth="1px"
                borderColor="blue"
                onClick={handleGenerateReport}
              >
                Refresh
              </Button>
            </Flex>
          </Box>
        )}

        {/* Detailed Reports Section */}
        {showCharts && (
          <Box bg="white" rounded={10} p={6} mt={4}>
            <Heading size="lg" mb={6} color="gray.400" fontWeight="medium">
              Detailed Analysis Report
            </Heading>
            {/* Your existing report components */}
            <SimpleGrid
              columns={{ base: 1, md: 2, xl: 2 }}
              gap="20px"
              mb="20px"
            >
              <SuspectedBrandsTable finalData={topSuspectedBrands} />
              <PieCard finalData={topSuspectedBrands} />
            </SimpleGrid>
            
            {(topSuspectedSellers && topSuspectedSellers.length > 0) && (<>

              <SimpleGrid
                columns={{ base: 1, md: 2, xl: 2 }}
                gap="20px"
                mb="20px"
              >
                <SuspectedSellers finalData={topSuspectedSellers} />
                <PieCard finalData={topSuspectedSellers} />
              </SimpleGrid>
            </>)}
            <SimpleGrid
              columns={{ base: 1, md: 2, xl: 2 }}
              gap="20px"
              mb="20px"
            >
              <InfringingPlatforms finalData={topInfringingPlatforms} />
              <PieCard finalData={topInfringingPlatforms} />
            </SimpleGrid>
            <Heading>
              {" "}
              <Flex
                px="25px"
                paddingBottom="10px"
                justify="space-between"
                align="center"
              >
                <Text
                  color={textColor}
                  fontSize="32px"
                  fontWeight="700"
                  lineHeight="100%"
                  m="auto"
                >
                  Detail Analysis
                </Text>
              </Flex>
            </Heading>

            <SimpleGrid
              columns={{ base: 1, md: 2, xl: 2 }}
              gap="20px"
              mb="20px"
            >
              <BrandAnalysisTable finalData={brandWise} />
              <BarChart finalData={brandWise} what={"Brand"} />
            </SimpleGrid>
            <SimpleGrid
              columns={{ base: 1, md: 2, xl: 2 }}
              gap="20px"
              mb="20px"
            >
              <PlatformAnalysisTable finalData={platformWise} />
              <BarChart finalData={platformWise} what={"Platform"} />
            </SimpleGrid>
            <Heading>
              {" "}
              <Flex
                px="25px"
                paddingBottom="10px"
                justify="space-beBatween"
                align="center"
              >
                <Text
                  color={textColor}
                  fontSize="32px"
                  fontWeight="700"
                  lineHeight="100%"
                  m="auto"
                >
                  Test Purchase
                </Text>
              </Flex>
            </Heading>
            {lookalikeInfringement.length > 0 && (
              <SimpleGrid
                columns={{ base: 1, md: 2, xl: 2 }}
                gap="20px"
                mb="20px"
              >
                <LookalikeInfringementTable finalData={lookalikeInfringement} />
                <LookalikeInfringementBar
                  finalData={lookalikeInfringement}
                  what={"Lookalike Infringement"}
                />
              </SimpleGrid>
            )}
            <SimpleGrid
              columns={{ base: 1, md: 2, xl: 2 }}
              gap="20px"
              mb="20px"
            >
              <TestPurchaseTable finalData={test} />
              <TestPie finalData={test} />
            </SimpleGrid>

            {/* <SimpleGrid columns={{ base: 1, md: 1, xl: 1 }} gap='20px' mb='20px'>
          <CounterfeitSellerTable
            fetchedProducts={suspiciousProducts}
          />
        </SimpleGrid> */}

            <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
              {successAlert !== "" && (
                <Alert status="success" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {successAlert}
                </Alert>
              )}
              {failureAlert !== "" && (
                <Alert status="error" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {failureAlert}
                </Alert>
              )}
            </Stack>
          </Box>
        )}
      </Box>
    </>
  );
}
